export default [
  {
    section: 'REGISTRASI',
    list: [
      [
        'Siapa saja yang dapat menjadi Pemberi Pinjaman (Lender) di Kredit Pintar?',
        'Warga Negara Indonesia (WNI) atau Warga Negara Asing (WNA) berusia minimal 18 tahun. Bagi WNI, keabsahan identitas diri akan dibuktikan melalui dokumen KTP dan Rekening Bank di Indonesia. Sedangkan bagi WNA dapat menghubungi Customer Service Kredit Pintar.',
      ],
      [
        'Selain KTP, apakah bisa menggunakan kartu identitas lain untuk menjadi Pemberi Pinjaman di Kredit Pintar ?',
        'Syarat dan ketentuan menjadi Pemberi Pinjaman melalui dokumen KTP ( asli ), tidak dapat menggunakan dokumen SIM, Fotocopy KTP ( tidak asli ) ataupun kartu identitas lain.',
      ],
      [
        'Bagaimana cara mendaftar sebagai Pemberi Pinjaman (Lender) di Kredit Pintar?',
        'Download aplikasi "Kredit Pintar For Lender" baik pada iOS maupun Android, atau buka website www.kreditpintar.com. Setelah itu verifikasi nomor ponsel dan Anda akan mendapatkan kode OTP via SMS.',
      ],
      [
        'Bagaimana cara membuat kata sandi pada akun Pemberi Pinjaman di Kredit Pintar ?',
        'Kata sandi di akun Pemberi Pinjaman di Kredit Pintar harus berisi 8-16 karakter yang terdiri dari kombinasi "huruf" dan "angka".',
      ],
    ],
  },
  {
    section: 'KYC (Know Your Customer)',
    list: [
      [
        'Apa yang perlu dilakukan ketika sudah terdaftar di akun Pemberi Pinjaman?',
        '<div>1. Upload foto KTP Asli untuk proses verifikasi</div>' +
        '<div>2. Sistem kami akan mencocokkan identitas pada akun dan KTP. Jika terdapat ketidaksesuaian data, mohon upload ulang dengan KTP Asli dan foto yang lebih jelas.</div>',
      ],
      [
        'Apa tahap berikutnya jika akun pendanaan telah selesai dibuat?',
        '<div>1. Masukkan data akun bank</div>' +
        '<div>2. Pastikan nama pada akun bank sesuai dengan nama di KTP. Jika ada perbedaan nama yang menyangkut gelar dsb, Anda dapat menghubungi Customer Service kami.</div>' +
        '<div>3. Pergantian akun bank dapat dilakukan maksimal 3x per bulan.</div>',
      ],
    ],
  },
  {
    section: 'Top Up Nominal',
    list: [
      [
        'Kapan saya bisa melakukan proses penyaluran dana nominal?',
        'Setelah Akun Pemberi Pinjaman terverifikasi, Anda dapat melakukan penyaluran dana nominal kapan pun Anda inginkan.',
      ],
      [
        'Apa saja metode penyaluran dana nominal yang tersedia?',
        'Penyaluran dana nominal dapat dilakukan melalui Virtual Account (VA), GOPAY, maupun transfer manual. Untuk VA, tersedia VA BCA (transfer hanya dari akun BCA), VA BNI (menerima dari semua akun bank). Manual Transfer bisa menggunakan rekening Bank CIMB. Sedangkan GOPAY, uang akan masuk ke pendanaan secara otomatis setelah transaksi tanpa masuk ke sisa nominal.',
      ],
      [
        'Apakah ada batas minimum/maksimum transfer dengan metode penyaluran dana tersebut?',
        '<div>Minimum transfer berlaku untuk manual transfer dengan nominal sebesar Rp 500 juta.</div>' +
        '<div>Maksumum transfer berlaku untuk GOPAY dengan nominal sebesar Rp 10 juta.</div>',
      ],
      [
        'Berapa lama dana tersebut bisa masuk ke akun pendanaan?',
        'Untuk VA & Gopay, dana diterima secara real time. Sedangkan untuk manual transfer, dana akan diterima 1x24 jam setelah melakukan konfirmasi kepada Customer Service kami.',
      ],
      [
        'Apakah saya dapat menarik kembali uang yang sudah diisi ulang ke nominal Kredit Pintar?',
        'Ya, Anda dapat menarik kembali uang yang sudah masuk di nominal Kredit Pintar jika Anda belum memulai Pendanaan.',
      ],
    ],
  },
  {
    section: 'FUNDING',
    list: [
      [
        'Apa saja produk Pendanaan Kredit Pintar yang tersedia?',
        'Anda dapat memilih produk yang sesuai dengan kebutuhan. Berikut 3 jenis produk pendanaan yang kami tawarkan :' +
        '<div style="padding-left: 15px">' +
        '<div>1 .Pendanaan Flexibel: Lender dapat melakukan penarikan dana kapanpun (min. 24 jam setelah melakukan pendanaan) dengan bunga yang diterima 9% (p.a.).</div>' +
        '<div>2. Pendanaan Berjangka: Lender dapat melakukan penarikan dana di akhir periode pendanaan dengan bunga yang disesuaikan dengan periode pendanaan yang dipilih, seperti berikut.</div>' +
        '<div style="padding-left: 25px">' +
        '<div>- 7 Hari, bunga 20% (p.a.)</div>' +
        '<div>- 30 Hari, bunga 12% (p.a.)</div>' +
        '<div>- 90 Hari, bunga 14% (p.a.)</div>' +
        '<div>- 180 Hari, bunga 16% (p.a.)</div>' +
        '<div>- 365 Hari, bunga 18% (p.a.)</div>' +
        '</div>' +
        '<div>3. Pendanaan Berjangka-VIP: Lender dapat melakukan penarikan dana di akhir periode pendanaan dengan bunga yang disesuaikan dengan periode pendanaan yang dipilih, seperti berikut.</div>' +
        '<div style="padding-left: 25px">' +
        '<div>- 30 Hari, bunga 15% (p.a.)</div>' +
        '<div>- 90 Hari, bunga 16% (p.a.)</div>' +
        '<div>- 180 Hari, bunga18 % (p.a.)</div>' +
        '<div>- 365 Hari, bunga 20% (p.a.)</div>' +
        '</div>' +
        '</div>',
      ],
      [
        'Berapa nominal minimum dan maksimum Pendanaan di Kredit Pintar?',
        '<div>1. Untuk pendanaan fleksibel, minimum pendanaan adalah Rp 50 ribu & maksimum Rp 10 juta.</div>' +
        '<div>2. Untuk pendanaan berjangka, minimum pendanaan adalah Rp 50 ribu, tanpa maksimum.</div>' +
        '<div>3. Untuk pendanaan berjangka-VIP, minimum pendanaan adalah Rp 1 M, tanpa maksimum.</div>',
      ],
      [
        'Apakah saya dapat menarik kembali uang yang sudah dicairkan sebelum periode pendanaan berakhir?',
        '<div>Untuk produk Pendanaan Berjangka & VIP, Anda tidak dapat menarik kembali uang dalam pendanaan sebelum periode pendanaan berakhir.</div>' +
        '<div>Sedangkan untuk Pendanaan Fleksibel, penarikan dana dapat dilakukan minimum 24 jam dari waktu melakukan pendanaan.</div>',
      ],
      [
        'Kapan saya bisa mencairkan dana beserta keuntungannya?',
        '<div>Untuk Pendanaan Berjangka dan VIP, modal awal ditambah bunga dapat dicairkan saat periode pendanaan berakhir.</div>' +
        '<div>Sedangkan Pendanaan Fleksibel, dana dapat ditarik kapanpun.</div>' +
        '<div>Kami akan mengirimkan SMS notifikasi saat pendanaan Anda telah berakhir.</div>',
      ],
      [
        'Apakah yang dimasud dengan "Diskon" pada keterangan di akun pendanaan?',
        'Diskon adalah program khusus yang memberi keuntungan lebih bagi Anda dalam melakukan pendanaan. Diskon dapat berupa voucher maupun kupon.' +
        '<div style="padding-left: 15px">' +
        '<div>- Voucher: Berupa kode yang diberikan oleh Kredit Pintar pada kesempatan/event tertentu. Setelah kode tersebut dimasukkan, akan ada penawaran produk pendanaan baru pada akun Anda. Keuntungan yang terima berupa bunga yang lebih besar.</div>' +
        '<div>- Kupon: Berbeda dengan voucher, kupon akan secara otomatis berada pada akun Anda (berdasarkan penilaian tertentu) ataupun melalui link (ketika ada event atau kesempatan tertentu). Kupon memiliki beberapa tipe :</div>' +
        '<div style="padding-left: 25px">' +
        '<div>1. Extramoney: Merupakan uang yang diberikan kepada Anda, dimana uang tersebut akan Anda dapatkan ketika melakukan pendanaan terlebih dahulu.</div>' +
        '<div>2. Cashback: Merupakan uang yang diberikan kepada Anda, dimana uang tersebut akan masuk ke sisa nominal dan dapat langsung ditarik atau digunakan untuk pendanaan.\n</div>' +
        '<div>3. Extra Interest Rate: Merupakan tambahan bunga yang diberikan dari bunga yang biasa diterima.</div>' +
        '</div>' +
        '</div>' +
        '*) syarat dan ketentuan berlaku',
      ],
    ],
  },
  {
    section: 'GENERAL',
    list: [
      [
        'Berapa nilai minimal dan maksimal yang ditetapkan untuk memulai pendanaan di Kredit Pintar?',
        'Setoran minimal untuk memulai pendanaan di Kredit Pintar adalah Rp 50.000, tanpa maksimal.',
      ],
      [
        'Apakah ada biaya untuk melakukan pendanaan di Kredit Pintar?',
        'Kredit Pintar tidak memungut biaya apapun dari Lender.',
      ],
      [
        'Kapan saya bisa mencairkan dana beserta keuntungannya?',
        'Anda dapat melakukan penarikan dana saat periode pendanaan berakhir (modal ditambah bunga yang didapatkan). Penarikan dapat dilakukan jika sisa nominal minimal sebesar Rp 10 ribu.',
      ],
      [
        'Apakah aman menjadi Pemberi Pinjaman (Lender) di Kredit Pintar?',
        'Ya, aman. Kredit Pintar melakukan seleksi dan analisa terhadap seluruh calon Peminjam. Dengan menggunakan Teknologi Model Credit Scoring yang kami terapkan hanya peminjam yang memenuhi kriteria kelayakan yang dapat melakukan pinjaman di Kredit Pintar. Kami menjunjung transparansi terhadap pihak pemegang risiko. Saat ini Kredit Pintar telah resmi terdaftar sebagai perusahaan Fintech yang di awasi oleh Otoritas Jasa Keuangan (OJK) sejak April 2018.',
      ],
      [
        'Apakah ada risiko menjadi Lender di Kredit Pintar?',
        'Ada. Namun Kredit Pintar telah melakukan pengurangan risiko dengan mengimplementasikan penilaian kredit (Credit Scoring) berbasis teknologi Artificial Intelligence (AI). Dengan perhitungan dan pengelolaan risiko dalam proses analisa terhadap semua pengajuan dan pemberian pinjaman, risiko dapat ditekan hingga level minimum.',
      ],
      [
        'Bagaimana jika Peminjam (Borrower) gagal melakukan pembayaran?',
        'Untuk meminimalisasi risiko wanprestasi, Kredit Pintar akan melakukan analisis, seleksi, dan persetujuan berdasarkan sistem Credit Scoring yang terkini terhadap setiap pinjaman yang diajukan. Setelah dana Lender dicairkan kepada Borrower, Kredit Pintar tetap melakukan pengawasan untuk memastikan bahwa tidak ada penyalahgunaan terhadap dana yang diberikan. Repayment pun dapat dilaksanakan tepat waktu. Jika Peminjam mengalami gagal bayar, Kredit Pintar akan segera mengambil tindakan untuk melindungi kepentingan Pemberi Pinjaman.',
      ],
      [
        'Bagaimana cara menghubungi Customer Service pendanaan Kredit Pintar?',
        '<div>Whatsapp: 081324887208</div>' +
        '<div>Email: pendanaan@kreditpintar.com</div>' +
        '<div>Working Hours : Senin-Jumat (09:30 -19:30)</div>',
      ],
    ],
  },
  {
    section: 'REFUND',
    list: [
      [
        'Proses pengembalian dana ke akun bank Pemberi Pinjaman',
        'Kami membatasi waktu penyimpanan dana yang telah disetorkan ke Kredit Pintar selama 48 jam sejak dana tersebut masuk ke Kredit Pintar. Sistem kami akan secara otomatis mengembalikan dana tersebut ke akun bank yang terdaftar jika setelah 48 jam dana tidak digunakan untuk pendanaan maupun tidak ditarik. ',
      ],
    ],
  },
]
